import styled from 'styled-components'

export const BillingContentTitle = styled.h6`
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 8px;
  border-bottom: 1px solid #bebebe;
  margin-bottom: 30px;
`
